import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Sparkles } from "lucide-react";

const LINKS = [
    { label: "La comunidad", href: "#esencia" },
    { label: "Espacios", href: "#espacios" },
    { label: "Quién te acompaña", href: "#acompanamiento" },
    { label: "Acceso", href: "#precios" },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <motion.header
            data-testid="site-header"
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled ? "bg-alma-white/80 backdrop-blur-xl border-b border-alma-mist/60" : "bg-transparent"
            }`}
        >
            <div className="max-w-[1400px] mx-auto px-6 sm:px-8 lg:px-14 h-16 sm:h-20 flex items-center justify-between">
                <a href="#top" className="flex items-center gap-2.5 group" data-testid="brand-logo">
                    <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-alma-gold to-alma-goldDeep text-alma-white">
                        <Sparkles className="h-4 w-4" strokeWidth={1.4} />
                    </span>
                    <span className="font-serif text-xl sm:text-[22px] tracking-tight text-alma-ink">
                        Alquimia <span className="italic font-light text-alma-goldDeep">del Alma</span>
                    </span>
                </a>

                <nav className="hidden lg:flex items-center gap-9">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            className="relative text-sm text-alma-slate hover:text-alma-ink transition-colors group"
                        >
                            {l.label}
                            <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-alma-gold transition-all duration-300 group-hover:w-full" />
                        </a>
                    ))}
                </nav>

                <div className="flex items-center gap-2">
                    <a
                        href="#precios"
                        data-testid="nav-cta"
                        className="hidden sm:inline-flex items-center rounded-full bg-alma-ink hover:bg-alma-night text-alma-white px-5 h-10 text-sm font-medium transition-colors"
                    >
                        Quiero entrar
                    </a>
                    <button
                        className="lg:hidden inline-flex h-10 w-10 items-center justify-center rounded-full border border-alma-mist bg-alma-white/70 text-alma-ink"
                        onClick={() => setOpen((v) => !v)}
                        aria-label="Menú"
                    >
                        {open ? <X className="h-4 w-4" /> : <Menu className="h-4 w-4" />}
                    </button>
                </div>
            </div>

            <AnimatePresence>
                {open && (
                    <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        className="lg:hidden overflow-hidden border-t border-alma-mist bg-alma-white/95 backdrop-blur-xl"
                    >
                        <div className="px-6 py-6 flex flex-col gap-4">
                            {LINKS.map((l) => (
                                <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-base text-alma-ink">
                                    {l.label}
                                </a>
                            ))}
                            <a
                                href="#precios"
                                onClick={() => setOpen(false)}
                                className="rounded-full bg-alma-ink text-alma-white h-11 flex items-center justify-center font-medium"
                            >
                                Quiero entrar
                            </a>
                        </div>
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.header>
    );
}
